import {useAuthStore} from '~/stores/auth'
import {sessionFromPayload} from '~/utils/cookieSession'

/** Подхватывает httpOnly-cookie с родительского домена, не выпуская новый токен. */
export async function adoptSharedCookie(store = useAuthStore()) {
    if (store.isAuth) {
        return
    }

    const headers: Record<string, string> = {Accept: 'application/json'}

    if (import.meta.server) {
        const cookie = useRequestHeaders(['cookie']).cookie
        if (!cookie?.includes('access_token=')) {
            return
        }
        headers.Cookie = cookie
    }

    try {
        const data = await $fetch('/auth/session/', {
            baseURL: useApiBaseUrl(),
            headers,
            credentials: 'include',
        })
        const session = sessionFromPayload(data)
        if (!session) {
            return
        }
        store.setUserRole(session.role)
        store.setSessionExp(session.exp)
    } catch {
        // Нет cookie или токен уже недействителен.
    }
}
